import SearchBarRecurrence from './SearchBarRecurrence';

export default SearchBarRecurrence;
